export default __webpack_public_path__ + "static/media/TORAY_rogo.b2e57502.svg";